import React, { Component } from 'react'

class ChangeDataMITModal extends Component {

    ChangeNewMITUser = async (value) => {
        const { adminUsersModel, RefreshModel } = this.props
        adminUsersModel.new_user_MIT = value;
        RefreshModel(adminUsersModel)
    }

    ChangeNewMITPassword = async (value) => {
        const { adminUsersModel, RefreshModel } = this.props
        adminUsersModel.new_pass_MIT = value;
        RefreshModel(adminUsersModel)
    }


    render() {
        const { adminUsersModel, action, editMode, SaveChangeData, CloseChangeMITDataModal } = this.props

        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="changeMITDataModal" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="changePasswordModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">Cambiar datos MIT</h4>
                            &nbsp;
                            <button type="button" className="close" onClick={CloseChangeMITDataModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-1">
                                    </div>
                                    <div className="col-10">
                                        <div className="w-100 tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>
                                            {/* USER */}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Nuevo usuario</span>
                                                </div>
                                                <input className="form-control"
                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                                    // type={typeVisibilityOld === false ? 'text' : 'password'}
                                                    // disabled={(action === 2 && !editMode) ? true : false}
                                                    onChange={(event) => this.ChangeNewMITUser(event.target.value)}
                                                    value={adminUsersModel?.new_user_MIT ?? ""}
                                                />

                                            </div>
                                            {/* PASSWORD */}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Nueva contraseña</span>
                                                </div>
                                                <input className="form-control"
                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                                    // type={typeVisibilityOld === false ? 'text' : 'password'}
                                                    // disabled={(action === 2 && !editMode) ? true : false}
                                                    onChange={(event) => this.ChangeNewMITPassword(event.target.value)}
                                                    value={adminUsersModel?.new_pass_MIT ?? ""}
                                                />

                                            </div>


                                        </div>
                                    </div>
                                    <div className="col-1">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={CloseChangeMITDataModal} >
                                Cerrar
                            </button>
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect"
                                    onClick={SaveChangeData}>
                                    Cambiar datos
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ChangeDataMITModal